import React, { useRef, useState } from 'react';

import { Root, Track, Range, Thumb } from '@radix-ui/react-slider';

const THROTTLE_DELAY = 75;

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/fields.d.ts').Slider}
 */
export const BaseSlider = ({
    defaultValue,
    max=100,
    min=0,
    name,
    onChange = () => { },
    onDebouncedChange = () => { },
    step = 1,
    value,
}) => {
    const [_value, setValue] = useState(value);
    const timeoutRef = useRef(null);

    /** @type {(nextValue: number[]) => void} */
    const handleChange = (nextValue) => {
        setValue(nextValue);

        onChange(nextValue);

        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = window.setTimeout(() => {
            onDebouncedChange(nextValue);
        }, THROTTLE_DELAY);
    };

    return (
        <Root
            className='slider__root'
            defaultValue={defaultValue || [min, max]}
            max={max}
            min={min}
            minStepsBetweenThumbs={1}
            name={name}
            onValueChange={handleChange}
            step={step}
            value={_value}>
            <Track className='slider__track'>
                <Range className='slider__range' />
            </Track>
            <Thumb className='slider__thumb' />
            <Thumb className='slider__thumb' />
        </Root>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default BaseSlider;
